module.exports = __webpack_public_path__ + "static/media/th.986613b9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/th.svg
// module id = 2223
// module chunks = 0